<template>
  <div>
    <vxe-modal
      v-model="dialogVisible"
      :before-hide-method="handleClose"
      width="80%"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>用户</span>
      </template>
      <template #default>
        <div class="single-content-wrapper">
          <el-row class="btn-row">
            <!-- 按钮节点区域-->
            <div class="option">
              <el-button
                @click="handleConfirm('userinfo')"
                v-if="Opt != 'view'"
              >
                <span>提交</span>
              </el-button>
              <el-button
                type="primary"
                @click="Operation(1)"
                v-if="Opt == 'view'"
              >
                {{ userinfo.state == 0 ? "禁用" : "启用" }}</el-button
              >
              <el-button
                type="primary"
                @click="passworedialogShow"
                v-if="Opt == 'view'"
              >
                修改密码</el-button
              >
              <el-button @click="handleCancel">
                <span>关闭</span>
              </el-button>
            </div>
          </el-row>
          <div class="switch-display border-all">
            <!-- 表单区域-->
            <div class="switch-content">
              <el-form
                ref="userinfoform"
                :model="userinfo"
                :disabled="Opt == 'view'"
                :rules="rules"
                size="small"
              >
                <div class="formtable">
                  <el-row :gutter="20" class="row-bg">
                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="用户代码:" prop="code">
                          <el-input
                            id="code"
                            v-model="userinfo.code"
                            :disabled="Opt != 'insert'"
                            clearable
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="用户姓名:" prop="name">
                          <el-input
                            id="name"
                            v-model="userinfo.name"
                            clearable
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="昵称:" prop="nickName">
                          <el-input
                            id="nickName"
                            v-model="userinfo.nickName"
                            clearable
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item>
                          <el-checkbox
                            v-model="userinfo.state"
                            :true-label="1"
                            :false-label="0"
                            disabled
                            >用户状态</el-checkbox
                          >
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20" class="row-bg">
                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="手机/电话:" prop="phone">
                          <el-input
                            id="phone"
                            v-model="userinfo.phone"
                            clearable
                            οninput="value=value.replace(/[^\d]/g,'');if(value.length > 11)value = value.slice(0, 11)"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="邮箱地址:" prop="mail">
                          <el-input
                            id="mail"
                            v-model="userinfo.mail"
                            clearable
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20" class="row-bg">
                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="创建时间:" prop="creationTime">
                          <el-date-picker
                            :value="userinfo.creationTime"
                            v-model="userinfo.creationTime"
                            type="datetime"
                            disabled
                          ></el-date-picker>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="创建人:" prop="creatorId">
                          <el-input
                            id="creatorId"
                            disabled
                            v-model="userinfo.creatorId"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item
                          label="最后修改时间:"
                          prop="lastModificationTime"
                        >
                          <el-date-picker
                            v-model="userinfo.lastModificationTime"
                            type="datetime"
                            disabled
                          ></el-date-picker>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="最后修改人:" prop="lastModifierId">
                          <el-input
                            id="lastModifierId"
                            v-model="userinfo.lastModifierId"
                            disabled
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
            </div>
          </div>
          <password
            :dialogVisible="passworedialogVisible"
            @password-submitForm="Operation"
            @password-close="passwordclose"
          ></password>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import {
  InsertUser,
  UpdateUser,
  UpdataUserState,
  UpdataUserPossword,
  selectByCodeID,
} from "@api/user";
import { GetAllUserGroupInfo } from "@api/usergroup";

import { ref, reactive, onMounted, onUpdated, toRefs, unref } from "vue";
import { ElNotification, ElMessage } from "element-plus";
import password from "./Password.vue";

export default {
  components: {
    password,
  },
  name: "userEidt",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  setup(prop, content) {
    const usergroup = reactive([]);
    onMounted(() => {});

    const passworedialogShow = () => {
      passworedialogVisible.value = true;
    };
    const passworedialogVisible = ref(false);
    const Operation = (val, password) => {
      //启用和更新密码
      if (val == 1) {
        //更新状态
        let params = {
          userId: data.userinfo.id,
          state: data.userinfo.state == 0 ? 1 : 0,
        };
        UpdataUserState(params)
          .then((res) => {
            if (res) {
              //刷新
              Refresh(data.userinfo.id);
              ElMessage.success("状态更新成功！！！");
            } else ElMessage.error("状态更新失败！！！");
          })
          .catch(({ message }) => {
            ElMessage.error(message);
          });
      } else {
        //更新密码
        UpdataUserPossword({ userId: data.userinfo.id }, { password })
          .then((res) => {
            if (res) {
              //刷新
              Refresh(data.userinfo.id);
              ElMessage.success("密码更新成功");
              passwordclose();
            } else ElMessage.error("密码更新失败");
          })
          .catch(({ message }) => {
            ElMessage.error(message);
          });
      }
    };
    const userinfoform = ref(null);
    const handleSelect = (item) => {
      console.log(item);
    };
    const handleClick = (tab, event) => {
      console.log(tab, event);
    };
    const handleClose = () => {
      Object.assign(data, OriginalData());
      content.emit("close-dialog");
    };
    const passwordclose = () => {
      passworedialogVisible.value = false;
    };
    const handleCancel = () => {
      handleClose();
    };
    const handleConfirm = (formName) => {
      userinfoform.value.validate((valid) => {
        if (valid) {
          if (data.Opt == "update") {
            UpdateUser(data.userinfo)
              .then((res) => {
                if (res) {
                  Refresh(res.id);
                  ElMessage.success("更新成功!");
                  data.Opt = "view";
                  content.emit("handle-confirm", "");
                } else ElMessage.error("更新失败!");
              })
              .catch(({ message }) => {
                ElMessage.error(message);
              });
          } else if (data.Opt == "insert") {
            let userDto = {
              yZUser: data.userinfo,
              UserGropMX: data.YUZ,
            };
            InsertUser(JSON.stringify(userDto))
              .then(function (result) {
                if (result.status == 200) {
                  ElMessage.success("新增成功！");
                  data.Opt = "view";
                  content.emit("handle-confirm", "");
                } else {
                  ElMessage.error("新增失败!" + result.message);
                }
              })
              .catch((error) => {
                ElMessage.error("新增失败!" + error);
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };

    const OriginalData = () => {
      return {
        dialogVisible: false,
        Opt: "",
        YUZ: [],
        possword: "",
        rules: {
          code: [
            {
              required: true,
              message: "请输入员工编号",
              trigger: "blur",
            },
            {
              min: 3,
              max: 15,
              message: "长度在3到5之间",
              trigger: "blur",
            },
          ],
          name: [
            {
              required: true,
              message: "请输入员工姓名",
              trigger: "blur",
            },
          ],
          mail: [
            {
              required: true,
              message: "请输邮箱地址",
              trigger: "blur",
            },
            {
              type: "mail",
              message: "请正确输入邮箱地址",
              trigger: ["blur", "change"],
            },
          ],
          phone: [
            {
              required: true,
              message: "请输入手机号",
              trigger: "blur",
            },
            { min: 11, message: "手机号格式不正确", trigger: "blur" },
          ],
        },
        userinfo: {},
      };
    };

    let data = reactive(OriginalData());
    onUpdated(() => {
      //清除校验
      const form = unref(userinfoform);
      if (!form) return;
      form.clearValidate();
    });
    //初始化页面
    const initDialog = (Opt, row) => {
      data.Opt = Opt;
      if (row) {
        data.userinfo = { ...row };
      }
    };

    const Refresh = (userId) => {
      selectByCodeID({ userId })
        .then((res) => {
          data.userinfo = { ...res };
        })
        .catch();
    };
    return {
      ...toRefs(data),
      initDialog,
      usergroup,
      userinfoform,
      Operation,
      handleSelect,
      handleClick,
      handleClose,
      handleCancel,
      passworedialogShow,
      passworedialogVisible,
      handleConfirm,
      passwordclose,
    };
  },
};
</script>

<style lang="scss" scoped>
.formtable {
  padding: 0 20px;
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 5px 0;
}

.Commit {
  padding: 20px 0;
  text-align: center;
}
::v-deep .el-form-item--small .el-form-item__label {
  width: 100px;
  text-align: left;
  padding: 0;
}

::v-deep .el-date-editor--datetime {
  width: 100%;
}
.textarea-note {
  font-size: var(--el-form-label-font-size);
  padding: 5px 0;
}
.el-textarea {
  margin: 5px 0;
  width: 100%;
}
::v-deep .el-select {
  width: 100% !important;
  min-width: 20px;
}

.btn-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 5px;
}

.option {
  margin: 0px 0 20px 20px;
  .el-button {
    min-height: 0;
    background: #1c6de4;
    border-radius: 3px;
    font-size: 12px;
    color: #ffffff;
    padding: 12px 20px;
    border: 0;

    .custom-icon {
      font-size: 18px;
      vertical-align: text-bottom;
    }
  }
}
.single-content-wrapper {
  min-height: 60vh;
  background-color: #fff;
  padding-bottom: 15px;
}
.switch-display {
  position: relative;
}
.border-all {
  border: 1px solid #dcdfe6;
}
</style>
